// Public, guest-readable sample itineraries. No email gate, no signup.
// Copy is real and specific — used for AdSense "value content" and as a
// preview of what the Culinera planner produces.

export const SAMPLE_ITINERARIES = [
  {
    slug: "edmonton-food-weekend",
    title: "3-Day Edmonton Food Weekend",
    city: "Edmonton",
    duration: "3 days",
    metaDescription:
      "A sample 3-day Edmonton food weekend itinerary from Culinera — chef-led dinners, farmers' markets and casual local favourites. Read it free, no email or signup.",
    intro:
      "Edmonton rewards eaters who plan around neighbourhoods rather than single restaurants. This three-day weekend mixes chef-led dining with casual local favourites, and leaves room to wander between meals.",
    days: [
      {
        title: "Day 1 — Downtown and the core",
        body:
          "Start with a slow morning downtown: coffee and a bakery stop, then a walk through the river valley or the downtown farmers' market if it is a market day. Lunch is casual — one of the downtown lunch counters or pubs that locals actually queue for. Dinner is the weekend's first big meal: book ahead for one of Edmonton's chef-led rooms such as RGE RD, known for its Alberta-focused menu, or Bar Bricco for shareable plates and a strong wine list. Reservations are strongly recommended on Friday and Saturday nights.",
      },
      {
        title: "Day 2 — Markets, neighbourhoods, and a long dinner",
        body:
          "Morning: a farmers' market run (Old Strathcona on Saturday is the classic) for snacks, preserves, and a sense of what is in season. Lunch somewhere relaxed — Pip is a good bet for a bright, casual midday meal. Spend the afternoon on Whyte Avenue or 124 Street, where independent shops and cafes cluster. Dinner: The Butternut Tree for a refined take on Indigenous-inspired Alberta cuisine, or River City Revival House for a livelier room with a broad menu. If you are still going after dinner, the cocktail bars along 104 Street are an easy walk from most downtown hotels.",
      },
      {
        title: "Day 3 — One last great meal",
        body:
          "Sleep in, then brunch — Share Restaurant is a solid choice for a relaxed final meal before heading home. If you have a late departure, add a final stop: a bakery or coffee roaster for treats to take with you.",
      },
    ],
    notes:
      "Book dinners at least a week ahead in summer and during festival weekends; check hours before you go, as some kitchens close on Sundays or Mondays; and wear walking shoes — the best version of this trip is done mostly on foot.",
  },
  {
    slug: "calgary-banff-road-trip",
    title: "4-Day Calgary–Banff Food Road Trip",
    city: "Calgary & Banff",
    duration: "4 days",
    metaDescription:
      "A sample 4-day Calgary to Banff food road trip itinerary from Culinera — two days in Calgary, a Canmore stop and a Banff finish. Read it free, no email or signup.",
    intro:
      "This is Alberta's classic food road trip: two days in Calgary's dining scene, a mountain-town stop in Canmore, and a Banff finish. Drive time is short — Calgary to Banff is about 90 minutes — so the trip is about eating, not driving.",
    days: [
      {
        title: "Day 1 — Calgary: the Beltline and 17th Avenue",
        body:
          "Arrive in Calgary and settle into the Beltline or 17th Avenue area, where the city's densest restaurant strip is walkable. Lunch is casual — a cafe or counter spot on 17th. Dinner is the trip's first anchor: CHARCUT Roast House for Alberta beef and a buzzy room, or Deane House in a historic home by the river for a quieter, refined meal. Book dinner ahead; both are popular on weekends.",
      },
      {
        title: "Day 2 — Calgary: river paths and a second anchor",
        body:
          "Morning: walk or cycle the Bow River pathway, then brunch in Kensington or Inglewood — two of the city's most independent-minded neighbourhoods for food. Afternoon: the Central Library area and Stephen Avenue for a wander. Dinner: River Café on Prince's Island for seasonal Alberta cooking in a park setting, or Bar Chouette for a French-leaning wine-bar evening. If you want a third Calgary meal before leaving town, Rouge and EIGHT are both worth a detour.",
      },
      {
        title: "Day 3 — Canmore: mountain-town eating",
        body:
          "Drive west to Canmore (about an hour) and slow down. Lunch on Main Street — Crazyweed Kitchen is a reliable Canmore favourite, and 4296 offers a more polished mountain-town dining room. Afternoon: a walk along the Bow River or a short hike, then an early dinner before the Banff leg, or push on to Banff and eat there.",
      },
      {
        title: "Day 4 — Banff: the grand finish",
        body:
          "Banff Avenue is the main strip, but the best meals are a step off it. Lunch: a casual spot on Banff Avenue between sightseeing stops. Dinner, the trip's finale: The Bison Restaurant & Terrace for Rocky Mountain cuisine with a rooftop view, or Block Kitchen + Bar for a modern, relaxed room. Stay overnight in Banff if you can — the drive back to Calgary is easy in the morning, and the last dinner deserves a slow evening.",
      },
    ],
    notes:
      "Banff and Canmore restaurants book up in summer and ski season — reserve dinners two weeks ahead if you can; check seasonal hours, as some mountain kitchens reduce days in the shoulder seasons; and keep one meal unscheduled each day so you can follow a local recommendation.",
  },
];

export const getSampleItinerary = (slug) => SAMPLE_ITINERARIES.find((s) => s.slug === slug);
